<template>
  <div class="title-wrap">
    <img class="title-icon" src="@/assets/images/pc/left.png" alt="" />
    <span class="text"><slot></slot></span>
    <span class="text2"><slot></slot></span>
    <img class="title-icon" src="@/assets/images/pc/right.png" alt="" />
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scope>
.title-wrap {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 120px;
  position: relative;
  text-transform: uppercase;

  .title-icon {
    width: 195px;
  }
  .text {
    margin: 0 40px;
    font-size: 80px;
    display: block;
    height: 100px;
    line-height: 100px;
    font-weight: bold;
    color: #DCB579;
    background: linear-gradient(to bottom, #F4F6C4, #D9B06F);
    // background-image: -webkit-linear-gradient(bottom, red, #fd8403, yellow); 
    -webkit-background-clip: text; 
    -webkit-text-fill-color: transparent;
    position: relative;
    z-index: 300;
    white-space: nowrap;
  }

  .text2 {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    text-align: center;
    color: #4a0e00;
    font-size: 80px;
    font-weight: bold;
    transform: translateY(18px);
    z-index: 250;
  }
}
</style>